import styles from './styles.module.scss';
import SelectionWidget from './widget';

export { styles };
export default SelectionWidget;